var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col-12 col-md-6 col-lg-6 col-xl-6" }, [
        _c("h1", { staticClass: "modal-h1 mb-3" }, [
          _c("button", {
            staticClass: "btn btn-back",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.$emit("cancel")
              }
            }
          }),
          _vm._v(" "),
          _vm.type === "claim"
            ? _c("span", [_vm._v("\n          Refund Claim\n        ")])
            : _c("span", [_vm._v("\n          New Transaction\n        ")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 col-lg-6 col-xl-6" }, [
        _vm.type === "claim"
          ? _c("h5", { staticClass: "pull-right" }, [
              _c("small", [_vm._v("Settlement amount:")]),
              _vm._v(" "),
              _c("small", { staticClass: "text-danger" }, [
                _vm._v("$" + _vm._s(_vm.claim.settlement_amount))
              ])
            ])
          : _c("div", { staticClass: "d-flex flex-column remaining-price" }, [
              _vm.job.company.cash_discount_value > 0
                ? _c("div", [
                    _c("h5", [
                      _c("small", [
                        _vm._v("Remaining for credit card or split:")
                      ]),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-danger" }, [
                        _vm._v("$" + _vm._s(_vm.job.remaining_price))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("h5", [
                      _c("small", [_vm._v("Remaining for cash:")]),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-danger" }, [
                        _vm._v("$" + _vm._s(_vm.job.remaining_cash_price))
                      ])
                    ])
                  ])
                : _c("div", [
                    _c("h5", { staticClass: "pull-right" }, [
                      _c("small", [_vm._v("Balance due:")]),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-danger" }, [
                        _vm._v("$" + _vm._s(_vm.job.remaining_price))
                      ])
                    ])
                  ])
            ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("div", { staticClass: "row mb-1 mb-md-2 mb-lg-2 mb-xl-2" }, [
          _vm.type === "job"
            ? _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-6 col-lg-6 col-xl-6 pr-3 pr-md-0 pr-lg-0 pr-xl-0"
                },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Payment type:")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: {
                          options: _vm.paymentTypes,
                          placeholder: "Select Type"
                        },
                        on: {
                          input: function($event) {
                            _vm.errors.clear("payment_type_id")
                          }
                        },
                        model: {
                          value: _vm.transaction.payment_type_id,
                          callback: function($$v) {
                            _vm.$set(_vm.transaction, "payment_type_id", $$v)
                          },
                          expression: "transaction.payment_type_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "payment_type_id" }
                  })
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-6 col-lg-6 col-xl-6 pr-3 pr-md-0 pr-lg-0 pr-xl-0"
                },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Payment type:")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: {
                          options: _vm.refundType,
                          placeholder: "Select Type"
                        },
                        on: {
                          input: function($event) {
                            _vm.errors.clear("payment_type_id")
                          }
                        },
                        model: {
                          value: _vm.transaction.payment_type_id,
                          callback: function($$v) {
                            _vm.$set(_vm.transaction, "payment_type_id", $$v)
                          },
                          expression: "transaction.payment_type_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "payment_type_id" }
                  })
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-6 col-lg-6 col-xl-6 pl-3 pl-md-1 pl-lg-1 pl-xl-1"
            },
            [
              _c(
                "div",
                { staticClass: "select-wrap" },
                [
                  _c("label", [_vm._v("Payment method:")]),
                  _vm._v(" "),
                  _c("simple-select", {
                    attrs: {
                      options: _vm.paymentMethods,
                      placeholder: "Select Method"
                    },
                    on: {
                      input: function($event) {
                        _vm.errors.clear("payment_method_id")
                      }
                    },
                    model: {
                      value: _vm.transaction.payment_method_id,
                      callback: function($$v) {
                        _vm.$set(_vm.transaction, "payment_method_id", $$v)
                      },
                      expression: "transaction.payment_method_id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "payment_method_id" }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.transaction.payment_type_id === 2 &&
        _vm.transaction.payment_method_id === 4
          ? [
              _vm.job.charges
                ? [
                    _c(
                      "div",
                      [
                        _c("span", [
                          _vm._v(
                            "\n            Select a transaction you wish to refund:\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.jobCharges.filter(function(el) {
                            return (
                              el.payment_type_id === 1 ||
                              el.payment_type_id === 3
                            )
                          }),
                          function(charge, index) {
                            return _c(
                              "div",
                              { key: "trans-s-" + index, staticClass: "mt-2" },
                              [
                                _c("div", { staticClass: "row mb-2" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-2 text-right pt-2 pl-0 cc-n-umber radio-button-wrap"
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "pointer w-100 h-100",
                                          attrs: { for: "t" + index }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.transaction.charge_id,
                                                expression:
                                                  "transaction.charge_id"
                                              }
                                            ],
                                            attrs: {
                                              type: "radio",
                                              name: "charge_id",
                                              id: "t" + index
                                            },
                                            domProps: {
                                              value: charge.id,
                                              checked: _vm._q(
                                                _vm.transaction.charge_id,
                                                charge.id
                                              )
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.errors.clear("charge_id")
                                              },
                                              change: function($event) {
                                                _vm.$set(
                                                  _vm.transaction,
                                                  "charge_id",
                                                  charge.id
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "btn-radio"
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-3 charge-amount" },
                                    [
                                      _vm._v(
                                        "\n                $ " +
                                          _vm._s(charge.amount) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("h5", { staticClass: "col-3 d-inline" }, [
                                    _vm._v(_vm._s(charge.payment_type.name))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-4" }, [
                                    _vm._v(
                                      "\n                (**** " +
                                        _vm._s(charge.card.last4) +
                                        ")\n              "
                                    )
                                  ])
                                ])
                              ]
                            )
                          }
                        )
                      ],
                      2
                    )
                  ]
                : _c("div", { staticClass: "row mb-2" }, [_vm._m(0)]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "charge_id" }
              })
            ]
          : _vm.transaction.payment_type_id === 4 &&
            _vm.transaction.payment_method_id === 4
            ? [
                _vm.job.charges
                  ? [
                      _c(
                        "div",
                        [
                          _c("span", [
                            _vm._v(
                              "\n            Select a transaction you wish to refund:\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.jobCharges.filter(function(el) {
                              return (
                                el.payment_type_id === 1 ||
                                el.payment_type_id === 3
                              )
                            }),
                            function(charge, index) {
                              return _c(
                                "div",
                                {
                                  key: "trans-s-" + index,
                                  staticClass: "mt-2"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "row mb-2 card-info-wrap" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-2 text-right pt-2 pl-0 cc-n-umber radio-button-wrap"
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "pointer w-100 h-100",
                                              attrs: { for: "t" + index }
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.transaction.charge_id,
                                                    expression:
                                                      "transaction.charge_id"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  name: "charge_id",
                                                  id: "t" + index
                                                },
                                                domProps: {
                                                  value: charge.id,
                                                  checked: _vm._q(
                                                    _vm.transaction.charge_id,
                                                    charge.id
                                                  )
                                                },
                                                on: {
                                                  input: function($event) {
                                                    _vm.errors.clear(
                                                      "charge_id"
                                                    )
                                                  },
                                                  change: function($event) {
                                                    _vm.$set(
                                                      _vm.transaction,
                                                      "charge_id",
                                                      charge.id
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "btn-radio"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 charge-amount" },
                                        [
                                          _vm._v(
                                            "\n                $ " +
                                              _vm._s(charge.amount) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h5",
                                        { staticClass: "col-3 d-inline" },
                                        [
                                          _vm._v(
                                            _vm._s(charge.payment_type.name)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-4" }, [
                                        _vm._v(
                                          "\n                (**** " +
                                            _vm._s(charge.card.last4) +
                                            ")\n              "
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            }
                          )
                        ],
                        2
                      )
                    ]
                  : _c("div", { staticClass: "row mb-2" }, [_vm._m(1)]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "charge_id" }
                })
              ]
            : _vm.transaction.payment_method_id === 4 && _vm.job
              ? [
                  _vm.transaction.payment_method_id === 4
                    ? _c("payment", {
                        attrs: {
                          customer: _vm.job.customer,
                          company: _vm.job.company,
                          transaction: _vm.transaction,
                          width: "col-12"
                        },
                        on: {
                          update: function($event) {
                            _vm.$emit("update")
                          }
                        }
                      })
                    : _vm._e()
                ]
              : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-2" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-6 col-lg-6 col-xl-6 pr-3 pr-md-0 pr-lg-0 pr-xl-0"
            },
            [
              _c("div", { staticClass: "select-wrap" }, [
                _c("label", [_vm._v("Price:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.transaction.amount,
                      expression: "transaction.amount"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.transaction.amount },
                  on: {
                    keydown: function($event) {
                      _vm.errors.clear("amount")
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.transaction, "amount", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "amount" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 pl-1 transactions-overcharge" }, [
            _vm.transaction.payment_type_id === 4 &&
            _vm.transaction.payment_method_id === 4 &&
            _vm.transaction.amount > 0
              ? _c("span", { staticClass: "pl-2" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.job.company.charge_fee) +
                      "% is automatically added on the entered amount. Total for refund is $" +
                      _vm._s(
                        _vm.formatOverchargeAmount(
                          _vm.transaction.amount,
                          _vm.job.company.charge_fee
                        )
                      ) +
                      ".\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("div", { staticClass: "select-wrap h-auto" }, [
                _c("label", [_vm._v("Notes:")]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.transaction.note,
                      expression: "transaction.note"
                    }
                  ],
                  staticClass: "select-wrap-textarea form-control",
                  attrs: { rows: "5" },
                  domProps: { value: _vm.transaction.note },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.transaction, "note", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "note" }
              }),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "ref_id" }
              })
            ],
            1
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row w-100 job-buttons position-absolute" }, [
      _c("div", { staticClass: "col-12 py-2 border-top text-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.$emit("cancel")
              }
            }
          },
          [_vm._v("\n        Cancel\n      ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary ld-ext-right",
            class: _vm.loadingButton ? "running" : "",
            attrs: { type: "button", disabled: _vm.buttonDisabled },
            on: { click: _vm.createTransaction }
          },
          [
            _vm._v("\n        Save\n        "),
            _c("div", { staticClass: "ld ld-ball ld-flip" })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("span", { staticClass: "text-danger" }, [
        _vm._v("No refundable transactions")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("span", { staticClass: "text-danger" }, [
        _vm._v("No refundable transactions")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fb9430e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb9430e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transactions/TransactionsModal.vue
// module id = null
// module chunks = 